import { combineReducers } from 'redux';
import registerPrices from './index';

const appReducer = combineReducers({
  registerPrices: registerPrices,
});

export default appReducer;
